import { FC } from "react";
import { SingleValueProps } from "react-select";

import classNames from "classnames";

import { createComponentStyleHook } from "../../../../tokens";
import { OptionItem } from "../../OptionItem";

import tokenStyles from "./styles.module.css";
import legacyStyles from "./styles.module.scss";

const useResolvedDropdownSingleValueStyles = createComponentStyleHook<SingleValueProps<OptionItem | null>>({
  legacyStyles,
  tokenStyles,
  componentTokens: "dropdown_single_value",
});

/**
 * A selected single value within the ValueContainer.
 */
export const SingleValue: FC<SingleValueProps<OptionItem | null>> = (props) => {
  const { children, innerProps } = props;
  const { mode, styles, StyleModeBoundary } = useResolvedDropdownSingleValueStyles(props);

  const singleValueClassName = classNames(styles.SingleValue, "single-value");

  return (
    <StyleModeBoundary mode={mode}>
      <div {...innerProps} className={singleValueClassName}>
        {children}
      </div>
    </StyleModeBoundary>
  );
};
